import { cx } from '@emotion/css';

import { Button } from 'apps/shared/scripts/components';

import { activeClassName, pillButtonClassName } from './styles';
import { PillButtonProps } from './types';

type Props = PillButtonProps;

const PillButton = ({ active, faIcon, label, onClick }: Props) => {
  return (
    <Button
      className={cx(pillButtonClassName, { [activeClassName]: active })}
      faIcon={faIcon}
      onClick={onClick}
    >
      {label}
    </Button>
  );
};

PillButton.displayName = 'PillButton';

export default PillButton;
